(ns iris.side-panel.views
  (:require
   [cemerick.url :as cemerick.url]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [iris.common :as common]
   [iris.components.swipe :as swipe]
   [iris.events :as events]
   [iris.globals :as globals]
   [iris.posts.common :refer [reorder-post-id]]
   [iris.posts.subs :as posts-subs]
   [iris.posts.views.display-top-bar :refer [display-top-bar]]
   [iris.posts.views.filter-top-bar :as filter-top-bar]
   [iris.posts.views.posts-logs-switch :refer [posts-logs-switch]]
   [iris.routes :as routes]
   [iris.subs :as subs]
   [iris.utils :as utils]
   [clojure.string :as string]))


(def request-filters
  [{:id :all :label "All"}
   {:id :active :label "Running"}
   {:id :success :label "Done"}
   {:id :failure :label "Failed"}])

(def posts-control-options
  {:posts-panel {}
   :latest-panel {:level false :route "/last-25.php"}
   :posts-header-panel {:ws false :level false}
   :thread-panel {:ws false :level false}
   :user-panel {}
   :hashtag-panel {:ws false}
   :posts-ip-panel {}
   :posts-eid-panel {}
   :posts-cc-panel {}
   :search-panel {:filters false
                  :posts-logs false}})

(def logs-control-panels
  #{:logs-panel
    :logs-header-panel
    :logs-post-panel
    :logs-thread-panel
    :logs-ip-panel
    :logs-eid-panel
    :logs-user-panel})

(def logs-panels
  #{:posts-panel
    :latest-panel
    :posts-header-panel
    :thread-panel
    :user-panel
    :hashtag-panel
    :posts-ip-panel
    :posts-eid-panel
    :posts-cc-panel
    :search-panel})

(def tool-labels
  {:requests "Requests"
   :logs "Log"
   :filters "Filters"
   :search "Search"
   :settings "Settings"})

(def tool-icons
  {:requests "glyphicon-list-alt"
   :logs "glyphicon-time"
   :filters "glyphicon-flag"
   :search "glyphicon-search"
   :settings "glyphicon-cog"})

(defn request-status-label [status]
  (case status
    :failure "Failed"
    :success "Done"
    :active "Running"
    "Running"))

(defn filter-completed-requests [filter completed]
  (case filter
    :success (filterv #(= (:status %) :success) completed)
    :failure (filterv #(= (:status %) :failure) completed)
    completed))

(defn reagent-component? [x]
  (and (vector? x)
       (let [tag (first x)]
         (or (keyword? tag)
             (fn? tag)
             (symbol? tag)))))

(defn request-message [message]
  (when message
    [:div
     {:class "side-panel-request-message"}
     (if (reagent-component? message)
       message
       [:span {:dangerouslySetInnerHTML
               (reagent/unsafe-html message)}])]))

(defn request-item [request completed?]
  (let [status (:status request)
        failed? (= status :failure)
        active? (= status :active)
        success? (= status :success)
        status-class (cond
                       failed? "failure"
                       active? "active"
                       success? "success"
                       :else "default")
        display-time (if completed?
                       (:completed-at request)
                       (:started-at request))]
    [:li
     {:key (:id request)
      :class (str "side-panel-request-item side-panel-request-item-" status-class)}
     [:div
      {:class "side-panel-request-item-heading"}
      [:strong
       {:class "side-panel-request-item-label"}
       (:label request)]
      [:span
       {:class (str "side-panel-request-status side-panel-request-status-" status-class)}
       (request-status-label status)]]
     [request-message (:message request)]
     [:div
      {:class "side-panel-request-meta"}
      [:span
       (when display-time
         (.toLocaleTimeString (js/Date. display-time)))]
      (when completed?
        [:button
         {:type "button"
          :class "side-panel-link-button"
          :on-click #(re-frame/dispatch [::events/request-completed-clear (:id request)])}
         "clear"])]]))

(defn requests-tool []
  (let [active @(re-frame/subscribe [::subs/requests-active])
        completed @(re-frame/subscribe [::subs/requests-completed])
        current-filter @(re-frame/subscribe [::subs/side-panel-request-filter])
        visible-active (if (or (= current-filter :all) (= current-filter :active)) active [])
        visible-completed (if (= current-filter :active)
                            []
                            (filter-completed-requests current-filter completed))
        has-visible-requests? (or (seq visible-active) (seq visible-completed))]
    [:<>
     [:div.side-panel-requests-header
      [:strong.side-panel-section-heading "Requests"]
      (when (seq completed)
        [:button
         {:type "button"
          :class "side-panel-requests-clear"
          :on-click #(re-frame/dispatch [::events/request-completed-clear-all])}
         "clear completed"])]
     [:div.side-panel-request-filters
      (for [{:keys [id label]} request-filters]
        [:button
         {:key id
          :type "button"
          :class (str "side-panel-request-filter"
                      (when (= id current-filter)
                        " side-panel-request-filter-active"))
          :on-click #(re-frame/dispatch [::events/side-panel-set-request-filter id])}
         label])]
     (if has-visible-requests?
       [:<>
        (when (seq visible-active)
          (into [:ul.side-panel-request-list]
                (for [request visible-active]
                  [request-item request false])))
        (when (and (seq visible-active) (seq visible-completed))
          [:div.side-panel-request-separator])
        (when (seq visible-completed)
          (into [:ul.side-panel-request-list]
                (for [request visible-completed]
                  [request-item request true])))]
       [:div.side-panel-requests-empty
        "No requests."])]))

(defn moderator-logs-tool []
  (let [timer @(re-frame/subscribe [::posts-subs/timer])
        logs @(re-frame/subscribe [::posts-subs/moderation-logs])
        logs-desc (sort-by :ms #(compare %2 %1) logs)]
    timer
    [:div.side-panel-log-tool
     [:h3.side-panel-section-heading.side-panel-log-heading
      "Most recent post actions"]
     [:p.side-panel-log-description
      "Displaying the latest " (count logs) " log(s) of "
      (:limit-to-last globals/MODERATOR_LOG_SETTINGS) " max limit."]
     [:ul.side-panel-log-list
      (if (seq logs-desc)
        (map-indexed
         (fn [idx log]
           (let [relative2 (utils/dt2ago (.toISOString (js/Date. (:ms log))) true)
                 log-href (if (contains? log :ruid)
                            (str "/t/" (reorder-post-id (:ruid log)))
                            "")]
          [:li
           {:key (str "side-panel-log-" (:ms log) "-" (:ruid log) "-" (:action log))
            :class (str "side-panel-log-item "
                        (if (even? idx)
                          "side-panel-log-item-even"
                          "side-panel-log-item-odd"))}
           [:a
            {:href log-href
             :class "side-panel-log-link"}
            [:span.side-panel-log-ruid
             (:ruid log)]
            " "
            [:span.side-panel-log-action
             (:action log)]
            " "
            [:span.side-panel-log-time
             relative2]]]))
         logs-desc)
        [:li
         {:class "side-panel-log-empty"}
         "Moderator log list is empty"])]]))

(defn side-panel-control-section [label body]
  [:section.side-panel-control-section
   [:div.side-panel-section-heading
    label]
   body])

(defn filters-control-groups [query-params options]
  [:div
   [:div.side-panel-control-row
    [filter-top-bar/filter-top-bar-ws query-params options (:websites @globals/jwt-payload)]]
   (when (not (false? (:level options)))
     [:div.side-panel-control-row
      [filter-top-bar/filter-top-bar-level query-params]])
   (when (not (false? (:status options)))
     [:div.side-panel-control-row
      [filter-top-bar/filter-top-bar-status query-params]])
   (when (not (false? (:flag options)))
     [:div.side-panel-control-row
      [filter-top-bar/filter-top-bar-flag query-params]])
   (when (not (false? (:staff options)))
     [:div.side-panel-control-row
      [filter-top-bar/filter-top-bar-staff query-params]])])

(defn filters-tool [query-params options]
  (let [has-options? (some? options)
        show-filters? (and has-options?
                           (not (false? (:filters options))))
        show-posts-logs? (not (false? (:posts-logs options)))]
    [:div#side-panel-filters.side-panel-filters
     (when show-filters?
       [side-panel-control-section
        "Filters"
        [filters-control-groups query-params options]])
     (when has-options?
       [side-panel-control-section
        "Display"
        [display-top-bar query-params {:label? false
                                       :refresh-row? true}]])
     (when show-posts-logs?
       [side-panel-control-section
        "Posts / Logs"
        [posts-logs-switch]])]))

(defn side-panel-choice-button [selected? label on-click]
  [:button
   {:class (str "btn side-panel-choice-button " (if selected? "btn-primary" "btn-default"))
    :type "button"
    :on-click on-click}
   label])

(defn side-panel-choice-group [choices selected-value on-select]
  (into
   [:div
    {:class "btn-group btn-group-sm"
     :role "group"}]
   (for [{:keys [value label]} choices]
     [side-panel-choice-button (= selected-value value) label #(on-select value)])))

(defn search-input [value placeholder on-change]
  [:input.form-control
   {:aria-label placeholder
    :placeholder placeholder
    :type "search"
    :value value
    :class "side-panel-search-input"
    :on-change on-change}])

(defn search-submit-button [label]
  [:button.btn.btn-primary
   {:type "submit"
    :class "side-panel-search-submit"}
   label])

(defn route-to-search! [path query-params]
  (routes/route-to! (str path "?" (cemerick.url/map->query query-params))))

(defn side-panel-post-search [ws]
  (let [q (reagent/atom "")
        index (reagent/atom "admin")
        order (reagent/atom "desc")]
    (fn [ws]
      [:form
       {:class "side-panel-search-form side-panel-post-search-form"
        :on-submit (fn [e]
                     (.preventDefault e)
                     (route-to-search! (routes/url-for :search)
                                       {:index @index
                                        :order @order
                                        :ws ws
                                        :q @q}))}
       [:div
        {:class "side-panel-search-choices"}
        [side-panel-choice-group
         [{:value "admin" :label "admin"}
          {:value "public" :label "public"}]
         @index
         #(reset! index %)]
        [side-panel-choice-group
         [{:value "desc" :label "newest"}
          {:value "asc" :label "oldest"}]
         @order
         #(reset! order %)]]
       [search-input @q "Search posts" #(reset! q (-> % .-target .-value))]
       [:div
        {:class "side-panel-search-submit-with-help"}
        [search-submit-button "Search posts"]
        [common/search-help {:side-panel? true}]]])))

(defn side-panel-header-search [ws]
  (let [q (reagent/atom "")]
    (fn [ws]
      [:form
       {:class "side-panel-search-form"
        :on-submit (fn [e]
                     (.preventDefault e)
                     (route-to-search! (routes/url-for :header-search)
                                       {:ws ws
                                        :q @q
                                        :limit 50
                                        :page 1}))}
       [search-input @q "Search headers" #(reset! q (-> % .-target .-value))]
       [:div
        {:class "side-panel-search-submit-row"}
        [search-submit-button "Search headers"]]])))

(defn side-panel-rule-search [path placeholder submit-label]
  (let [q (reagent/atom "")]
    (fn [path placeholder submit-label]
      [:form
       {:class "side-panel-search-form"
        :on-submit (fn [e]
                     (.preventDefault e)
                     (let [q-value (string/trim @q)]
                       (if (empty? q-value)
                         (routes/route-to! path)
                         (route-to-search! path {:q q-value}))))}
       [search-input @q placeholder #(reset! q (-> % .-target .-value))]
       [:div
        {:class "side-panel-search-submit-row"}
        [search-submit-button submit-label]]])))

(defn side-panel-screening-search []
  [side-panel-rule-search
   (routes/url-for :screens)
   "Search screening"
   "Search screening"])

(defn side-panel-censoring-search []
  [side-panel-rule-search
   (routes/url-for :censors)
   "Search censoring"
   "Search censoring"])

(defn side-panel-accordion-section [{:keys [id label body]} active-section]
  (let [open? (= id @active-section)
        body-id (str "side-panel-accordion-body-" (name id))]
    [:section
     {:class "side-panel-accordion-section"}
     [:button
      {:type "button"
       :aria-controls body-id
       :aria-expanded (if open? "true" "false")
       :class (str "side-panel-accordion-button"
                   (when open?
                     " side-panel-accordion-button-active"))
       :on-click #(reset! active-section id)}
      [:span label]
      [:span
       {:class (str "glyphicon "
                    (if open?
                      "glyphicon-chevron-down"
                      "glyphicon-chevron-right")
                    " side-panel-accordion-icon")
        :aria-hidden "true"}]]
     (when open?
       [:div
        {:id body-id
         :class "side-panel-accordion-body"}
        body])]))

(defn side-panel-accordion [sections default-section]
  (let [active-section (reagent/atom default-section)]
    (fn [sections default-section]
      (when-not (some #(= (:id %) @active-section) sections)
        (reset! active-section default-section))
      (into
       [:div.side-panel-accordion]
       (for [section sections]
         ^{:key (:id section)}
         [side-panel-accordion-section section active-section])))))

(defn search-tool [ws]
  (let [active-ws (or ws "TLO")]
    [:div#side-panel-search.side-panel-search
     [side-panel-accordion
      [{:id :posts
        :label "Post Search"
        :body [side-panel-post-search active-ws]}
       {:id :headers
        :label "Header Search"
        :body [side-panel-header-search active-ws]}
       {:id :screening
        :label "Screening Search"
        :body [side-panel-screening-search]}
       {:id :censoring
        :label "Censoring Search"
        :body [side-panel-censoring-search]}]
      :posts]]))

(defn settings-tool []
  [:div#side-panel-settings.side-panel-settings
   [:strong.side-panel-section-heading "Settings"]
   [common/settings-panel]])

(defn side-panel-menu-height [roles]
  (let [base-links 6
        link-count (cond-> base-links
                     (contains? roles "developer") inc
                     (contains? roles "tester") inc)]
    (str (+ 8 (* 38 link-count)) "px")))

(defn side-panel-top [mobile? scrolled? menu-open? roles]
  (let [mobile-nav-height (if scrolled? "26px" "42px")
        menu-height (side-panel-menu-height roles)]
    (cond
      (and mobile? menu-open?)
      (str "calc(50px + " mobile-nav-height " + " menu-height ")")

      mobile?
      (str "calc(50px + " mobile-nav-height ")")

      scrolled?
      "calc(25px + 26px)"

      :else
      "calc(25px + 50px)")))

(defn available-tools [active-panel]
  (cond-> [:requests]
    (contains? logs-panels active-panel) (conj :logs)
    (or (contains? posts-control-options active-panel)
        (contains? logs-control-panels active-panel)) (conj :filters)
    true (conj :search)
    true (conj :settings)))

(defn tool-button [tool active-tool]
  (let [settings? (= tool :settings)]
    [:button
     {:key tool
      :type "button"
      :title (tool-labels tool)
      :aria-label (tool-labels tool)
      :class (str "side-panel-tool-button"
                  (when (= tool active-tool)
                    " side-panel-tool-button-active")
                  (when settings?
                    " side-panel-tool-button-settings"))
      :on-click #(re-frame/dispatch [::events/side-panel-set-active-tool tool])}
     [:span {:class (str "glyphicon "
                         (tool-icons tool)
                         " side-panel-tool-icon"
                         (when settings?
                           " side-panel-tool-icon-settings"))}]
     (when-not settings?
       [:span (tool-labels tool)])]))

(defn active-tool-body [active-tool query-params filter-options ws]
  (case active-tool
    :logs [moderator-logs-tool]
    :filters [filters-tool query-params filter-options]
    :search [search-tool ws]
    :settings [settings-tool]
    [requests-tool]))

(defn mobile-width? []
  (< (.-innerWidth js/window) 768))

(defn contains-target? [el target]
  (and el target (.contains el target)))

(defn side-panel-outside-target? [target]
  (let [panel (.getElementById js/document "side-panel")
        navbar-toggle (.getElementById js/document "navbar-side-panel-toggle")]
    (and (mobile-width?)
         panel
         (not (contains-target? panel target))
         (not (contains-target? navbar-toggle target)))))

(defn close-mobile-side-panel-on-outside-click [e]
  (when (side-panel-outside-target? (.-target e))
    (re-frame/dispatch [::events/side-panel-collapse])))

(defn side-panel-body []
  (let [active @(re-frame/subscribe [::subs/side-panel-active-tool])
        collapsed? @(re-frame/subscribe [::subs/side-panel-collapsed?])
        active-panel @(re-frame/subscribe [::subs/active-panel])
        query-params @(re-frame/subscribe [::posts-subs/query-params])
        ws @(re-frame/subscribe [::subs/ws-or])
        viewport-size @(re-frame/subscribe [::subs/viewport-size])
        navbar-scrolled? @(re-frame/subscribe [::subs/navbar-scrolled?])
        roles @(re-frame/subscribe [::subs/roles])
        menu-open? @(re-frame/subscribe [::subs/ui-surface-open? :mobile-navbar-menu])
        mobile? (and (:x viewport-size) (< (:x viewport-size) 768))
        narrow-mobile? (and mobile? (< (:x viewport-size) 375))
        sidebar-width (if mobile? "100vw" "365px")
        sidebar-bottom (if mobile? 0 "50px")
        sidebar-bottom-offset (if mobile? "0px" "50px")
        sidebar-z-index (if mobile? 10000 9998)
        scrolled? (true? navbar-scrolled?)
        sidebar-top (side-panel-top mobile? scrolled? menu-open? roles)
        tools (available-tools active-panel)
        active-tool (if (some #{active} tools) active :requests)
        filter-options (get posts-control-options active-panel)]
    [:<>
     (when-not collapsed?
       [swipe/swipeable
        {:as :aside
         :id "side-panel"
         :enabled? mobile?
         :direction :left
         :ignore-selector "input[type=range]"
         :on-swipe #(re-frame/dispatch [::events/ui-surface-close :side-panel])
         :class "side-panel-shell"
         :style {:bottom sidebar-bottom
                 :max-height (str "calc(100dvh - " sidebar-top " - " sidebar-bottom-offset ")")
                 :top sidebar-top
                 :width sidebar-width
                 :z-index sidebar-z-index}}
        [:div
         {:class (str "side-panel-tool-row side-panel-tool-row-inner"
                      (when narrow-mobile?
                        " side-panel-tool-row-inner-narrow"))}
         (for [tool tools]
           [tool-button tool active-tool])]
        [:div
         {:class (str "side-panel-content"
                      (when mobile?
                        " side-panel-content-mobile"))}
         [active-tool-body active-tool query-params filter-options ws]]])]))

(defn side-panel []
  (reagent/create-class
   {:display-name "side-panel"
    :component-did-mount
    (fn [_]
      (.addEventListener js/document "click" close-mobile-side-panel-on-outside-click true))
    :component-will-unmount
    (fn [_]
      (.removeEventListener js/document "click" close-mobile-side-panel-on-outside-click true))
    :reagent-render side-panel-body}))
